<div id="engine-wrapper" class="engine-wrapper wrapper-hiden">
  <a (click)="redirect()" class="p-5 text-center link-to-client link-logo" type="button" style="position: absolute"
    *ngIf="scene && scene['client']">
    <div>
      <img class="logo" [src]="client.logo" alt="" />
      <div>{{ client.text }}</div>
    </div>
  </a>
  <div class="p-3 buttons-container-position">
    <a *ngIf="haveLinks" (click)="toogleLinks()"
      class="text-decoration-none bg-dark p-3 text-white d-flex justify-content-center link-to-client rounded primary"
      type="button">
      <span [ngClass]="!areShowingLinks ? 'icon-view-show' : 'icon-view-hide'"></span>
    </a>
    <a *ngIf="haveLinks" (click)="toogleHelp()"
      class="text-decoration-none bg-dark p-3 text-white d-flex justify-content-center link-to-client rounded primary second-button"
      type="button">
      <span class="icon-question-circle-o"></span>
    </a>
    <!-- <a (click)="toogleFullscreen()"
      class="text-decoration-none bg-dark p-3 text-white d-flex justify-content-center link-to-client rounded primary second-button"
      type="button">
      <span [class.icon-shrink2]="isInFullScreen()" [class.icon-enlarge2]="!isInFullScreen()"></span>
    </a> -->
  </div>

  <app-modal (close)="closeModal()" *ngIf="currenItem || helpOpened" [item]="currenItem" [movementType]="movementType"
    [helpOpened]="helpOpened" [client]="client"></app-modal>
  <app-spinner class="animation-container justify-content-center align-items-center element-animation z-index-one"
    [class.animation-container-hidden]="!loading"></app-spinner>
  <canvas #rendererCanvas id="renderCanvas"></canvas>
</div>

<app-viewer id="viewer" *ngIf="newViewer" [product]="product"></app-viewer>